<template>
  <div class="feedback-supplement">
    <div v-for="(item, index) in data" :key="index" class="feedback-supplement-item">
      <div v-if="item.role==='staff'" class="row item">
        <div>
          <div class="row staff-info">
            <div class="staff-info-username">{{item.userName}}</div>
            <div>{{item.reply_time}}</div>
          </div>
          <div class="content">{{item.content}}</div>
        </div>
        <div></div>
      </div>
      <div v-if="item.role==='user'" class="row item">
        <div></div>
        <div>
          <div class="row user-info">
            <div></div>
            <div class="row">
              <div>{{item.reply_time}}</div>
              <div class="user-username">{{item.userName}}</div>
            </div>
          </div>
          <span class="content user-content">{{item.content}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback-supplement {
  padding: 16px 0;
  .feedback-supplement-item {
    margin-bottom: 16px;
    .item {
      justify-content: space-between;
      .staff-info {
        margin-bottom: 8px;
        color: #2b76ff;
        font-size: 12px;
        font-weight: 500;
        .staff-info-username {
          margin-right: 8px;
        }
      }
      .user-info {
        justify-content: space-between;
        margin-bottom: 8px;
        color: #747990;
        font-size: 12px;
        font-weight: 500;
        .user-username {
          margin-left: 8px;
        }
      }
      .content {
        display: inline-block;
        padding: 12px;
        max-width: 477px;
        border-radius: 2px;
        color: #747990;
        background-color: #fafafc;
        font-size: 14px;
      }
      .user-content {
        float: right;
      }
    }
  }
}
</style>
